/** UOM / Pack-type — values enforced in API + UI, not DB CHECK. Expanded for Pricebook import. */
export const INVENTORY_AUDITOR_UOM_PACK_TYPES = [
  "$2 OFF",
  "1/2GAL",
  "10PK",
  "12PK",
  "15PK",
  "16OZ",
  "16PK",
  "18PK",
  "20PK",
  "24OZ",
  "24PK",
  "2PK",
  "30PK",
  "4PK",
  "6PK",
  "8PK",
  "9PK",
  "BOX",
  "CARTON",
  "EACH",
  "GAL",
  "PACK",
  "PPK1",
  "PPK10",
  "PPK100",
  "PPK110",
  "PPK12",
  "PPK120",
  "PPK14",
  "PPK144",
  "PPK145",
  "PPK15",
  "PPK16",
  "PPK18",
  "PPK180",
  "PPK2",
  "PPK20",
  "PPK200",
  "PPK21",
  "PPK24",
  "PPK25",
  "PPK26",
  "PPK28",
  "PPK3",
  "PPK3-8",
  "PPK30",
  "PPK32",
  "PPK36",
  "PPK4",
  "PPK4-6",
  "PPK40",
  "PPK48",
  "PPK5",
  "PPK50",
  "PPK6",
  "PPK6-4",
  "PPK60",
  "PPK7",
  "PPK72",
  "PPK78",
  "PPK8",
  "PPK9",
  "PT",
  "QT",
  "ROLL",
] as const;

export type InventoryAuditorUomPackType = (typeof INVENTORY_AUDITOR_UOM_PACK_TYPES)[number];

/** Size — values enforced in API + UI, not DB CHECK. Expanded for Pricebook import. */
export const INVENTORY_AUDITOR_SIZES = [
  "#10",
  ".33 OZ",
  ".37 OZ",
  ".83 OZ",
  ".92OZ",
  "0.5L",
  "0.5L 24PK",
  "1 50 OFF",
  "1 LT",
  "1 OFF",
  "1.06 OZ",
  "1.17 OZ",
  "1.25L",
  "1.27 OZ",
  "1.41  OZ",
  "1.53 OZ",
  "1.5L",
  "1.5OZ",
  "1.62 OZ",
  "1.75L",
  "1/2GAL",
  "10 QT",
  "10 S",
  "100",
  "100 FT",
  "100 GR",
  "100 PK",
  "100CT",
  "100ML",
  "10CT",
  "10LB",
  "10ML",
  "10OZ",
  "11.16OZ",
  "11.20Z",
  "11.2OZ",
  "11.5OZ",
  "112CT",
  "115 PK",
  "11OZ",
  "12 IN",
  "12 S",
  "120CT",
  "128 OZ",
  "12CT",
  "12OZ",
  "12PC",
  "12PK",
  "13.3 OZ",
  "13.5 OZ",
  "13.7OZ",
  "14.9OZ",
  "144CT",
  "14CT",
  "14OZ",
  "14PC",
  "15 LB",
  "15.2OZ",
  "15.5OZ",
  "15.8 OZ",
  "150CT",
  "15CT",
  "15OZ",
  "15PC",
  "16 OZ",
  "16.9OZ",
  "160Z",
  "16CT",
  "16OZ",
  "16PC",
  "17CT",
  "17OZ",
  "18.5OZ",
  "18.6OZ",
  "18.7 OZ",
  "18.8 OZ",
  "187ML",
  "18CT",
  "18PC",
  "18PK",
  "19 OZ",
  "19.2OZ",
  "19OZ",
  "1GAL",
  "1L",
  "1LB",
  "1OZ",
  "2 GAL",
  "2 PK",
  "2.20 OZ",
  "2.23 OZ",
  "2.45 OZ",
  "2.5 LB",
  "2.57 OZ",
  "2.5G",
  "2.5GAL",
  "2.5OZ",
  "2.82 OZ",
  "2.86 OZ",
  "2/$2",
  "2/6 PK",
  "20 PK",
  "20 S",
  "20 SLV",
  "200ML",
  "20CT",
  "20OZ",
  "20PK",
  "22OZ",
  "23.5OZ",
  "23.7OZ",
  "23OZ",
  "24 PK",
  "24 S",
  "24CT",
  "24OZ",
  "24PK",
  "25  OFF",
  "25 LB",
  "25 PK",
  "250ML",
  "25CT",
  "25OZ",
  "27OZ",
  "28OZ",
  "28PC",
  "2CT",
  "2L",
  "2LB",
  "2OZ",
  "2PK",
  "3 PK",
  "3.15LB",
  "3.5LB",
  "3.5OZ",
  "30 S",
  "30.4OZ",
  "30CT",
  "30K PUFF",
  "30PC",
  "32 PK",
  "32CT",
  "32OZ",
  "330ML",
  "34CT",
  "35 OZ",
  "355ML",
  "35PC",
  "36CT",
  "375ML",
  "39 OZ",
  "3CT",
  "3GAL",
  "3L",
  "3LB",
  "3LT",
  "3OZ",
  "3PK",
  "4 GR",
  "4 PK",
  "4 S",
  "4.24 OZ",
  "4.4LB",
  "4.56 OZ",
  "4.65 OZ",
  "4.84 OZ",
  "4.96 OZ",
  "40 S",
  "40CT",
  "40PC",
  "42 GR",
  "48OZ",
  "4CT",
  "4LB",
  "4OZ",
  "4PK",
  "5 OZ",
  "5 PK",
  "5.06 OZ",
  "5.07 OZ",
  "5.4 OZ",
  "5.52 OZ",
  "50  OFF",
  "50 FT",
  "50 S",
  "500ML",
  "50CT",
  "50LB",
  "50ML",
  "50PC",
  "56CT",
  "59OZ",
  "5CT",
  "5GAL",
  "5L",
  "5LB",
  "5OZ",
  "5PC",
  "6 IN",
  "6 PK",
  "6.2 LB",
  "6.5OZ",
  "6.8OZ",
  "6.9 OZ",
  "60CT",
  "64OZ",
  "6CT",
  "6OZ",
  "7 IN",
  "7.05 OZ",
  "7.5OZ",
  "7.7 LB",
  "700ML",
  "720ML",
  "7500 PUF",
  "750ML",
  "78 GR",
  "7OZ",
  "8.07 OZ",
  "8.4 OZ",
  "8.4OZ",
  "8.56 OZ",
  "8.5OZ",
  "8CT",
  "8LB",
  "8OZ",
  "8PK",
  "9.1OZ",
  "9.35 OZ",
  "9.5OZ",
  "9.6OZ",
  "9CT",
  "9OZ",
  "9PC",
  "B-2 9IN",
  "B-4 9IN",
  "BAG DN",
  "BITES",
  "BOTTLE",
  "BUCKET",
  "C2 10IN",
  "CAKE",
  "CAN",
  "CAN DIP",
  "CHARGER",
  "CRACKERS",
  "CT",
  "CTN",
  "DZN",
  "EACH",
  "FULL",
  "GMAS BIG",
  "GRAB",
  "JAR DIP",
  "KING",
  "KIT",
  "LD PP$1.00",
  "LRG",
  "MED",
  "MINI",
  "MINI GMAS",
  "OV RS",
  "PK",
  "PP $0.89",
  "PP$.50",
  "PP$.59",
  "PP$.69",
  "PP$.99",
  "PP$0.59",
  "PP$1",
  "PP$1.09",
  "PP$1.19",
  "PP$1.29",
  "PP$1.39",
  "PP$1.49",
  "PP$1.59",
  "PP$1.69",
  "PP$1.79",
  "PP$1.89",
  "PP$1.99",
  "PP$2",
  "PP$2.19",
  "PP$2.29",
  "PP$2.49",
  "PP$2.69",
  "PP$3.79",
  "PP$3.99",
  "PP$4.29",
  "PP$4.49",
  "PP$4.99",
  "PP$6.99",
  "PP-$0.59",
  "PP-$1.09",
  "PP-$2.39",
  "PROMO",
  "PRT MINI",
  "PSS",
  "PSZ",
  "PT",
  "QT",
  "RL",
  "SALSA",
  "SQUEEZE",
  "SS DIP",
  "STD",
  "STK",
  "SVLR",
  "THS",
  "XL",
  "XS",
  "XXL",
  "XXVL",
] as const;

export type InventoryAuditorSize = (typeof INVENTORY_AUDITOR_SIZES)[number];

/** How an IA catalog SKU entered the system. */
export const INVENTORY_AUDITOR_CATALOG_ORIGINS = ['pdi', 'scanned'] as const;
export type InventoryAuditorCatalogOrigin = (typeof INVENTORY_AUDITOR_CATALOG_ORIGINS)[number];

export const INVENTORY_AUDITOR_CATALOG_ORIGIN_PDI: InventoryAuditorCatalogOrigin = 'pdi';
export const INVENTORY_AUDITOR_CATALOG_ORIGIN_SCANNED: InventoryAuditorCatalogOrigin = 'scanned';

export function inventoryAuditorCatalogOriginLabel(origin: string | null | undefined): string {
  return origin === INVENTORY_AUDITOR_CATALOG_ORIGIN_SCANNED ? 'Scanned' : 'PDI inventory';
}

const UOM_SET = new Set<string>(INVENTORY_AUDITOR_UOM_PACK_TYPES);
const SIZE_SET = new Set<string>(INVENTORY_AUDITOR_SIZES);

export function isValidInventoryAuditorUomPackType(value: string | null | undefined): boolean {
  if (value == null || value === '') return false;
  return UOM_SET.has(String(value).trim());
}

export function isValidInventoryAuditorSize(value: string | null | undefined): boolean {
  if (value == null || value === '') return false;
  return SIZE_SET.has(String(value).trim());
}
